import getFirstStep from './getFirstStep';

export default getFirstStep;
